import { IconButton } from '@mui/material';
import React, { useEffect } from 'react'
import { Typography } from '@mui/material';
import { useState } from 'react';
import { Stack } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import { Draggable } from 'react-beautiful-dnd';

/**
 * studentName - the name of the student
 * 
 * endSemester - student's preferred end semester
 * 
 * groupRank - ranking of the current project they were put in
 * 
 * setLocked() - callback function to set the locked state of the student
 * 
 * openSidebar() - callback function to open the sidebar with this students info
 * 
 * @param {{ studentName: string, endSemester: string, groupRank: number, setLocked: () => void, openSidebar: () => void }} props 
 */
function StudentInfoCard( props ) {
    // { endSemester, groupRank, setLocked, openSidebar, width, height }) {
    const [locked, setLocked] = useState(false);
    const [data, setData] = useState(props.student);
    const [lockedList, setLockedList] = useState(props.lockedList); 


    const handleLockClick = (e) => {
        e.stopPropagation();
        setLocked(!locked);        
        props.locked(locked, data, data.user_id, props.project_id)
    }
    
    const cardStyle = {
        backgroundColor: locked ? '#D4FFDE' : '#ECF7FF',
        paddingInline: "1rem",
        borderRadius: 3,
        alignItems: 'center',
        justifyContent: "space-between",
        marginBottom: "7px"
    }

    useEffect(() => {
        //set lock when loaded if previously locked
        var found;
        props.lockedList.map(user => {
            if(user.user_id == data.user_id){
                found = true;
            }
        })
        if(!found){
            found = false
        }
        setLocked(found);

    }, [props.lockedList])
    

    return (
        <Draggable index={props.index} draggableId={data.user_id.toString()} isDragDisabled={locked}>
            {(provided) => (
                <div
                // spreadable children
                {...provided.draggableProps}
                // returns dom node of object
                {...provided.dragHandleProps}
                >
                    <Stack onClick={props.handleOpen} direction='row' spacing={1} style={cardStyle} ref={provided.innerRef}>
                        <Stack direction="row" sx={{width: "100%"}}>
                            <Typography style={{ width:'45%' }} >{data.first_name + " " + data.last_name.substring(0,20)}</Typography>
                            <Typography style={{ width:'15%' }} >{data.sd2_semester}</Typography>
                            <Typography style={{ width:'35%' }}>Ranking of Group: {props.projectRanking}</Typography>
                        </Stack>
                        <Stack>
                            <IconButton onClick={handleLockClick}>
                                {locked ? <LockIcon /> : <LockOpenIcon />}
                            </IconButton>
                        </Stack>
                    </Stack>
                </div>
            )}
        </Draggable>

    );
}

export default StudentInfoCard;